export class SerializedStateManager {
    constructor(consumerId, serverSideStateManager, clientSideStateManager) {
        this.consumerId = consumerId;
        this.serverSideStateManager = serverSideStateManager;
        this.clientSideStateManager = clientSideStateManager;
    }
    register(serializeState) {
        this.serverSideStateManager.register(this.consumerId, serializeState);
    }
    serializeStates() {
        return this.serverSideStateManager.serializeStates();
    }
    setSerializedStates(serializedStates) {
        this.clientSideStateManager.setSerializedStates(serializedStates);
    }
    getSerializedState() {
        return this.clientSideStateManager.getSerializedState(this.consumerId);
    }
}
//# sourceMappingURL=serialized-state-manager.js.map